import React from 'react';
import styled, { keyframes } from "styled-components";

import { get, mixin, toggle } from "package-common-react/lib/style/util";
import RoundedButton from "package-common-react/lib/components/RoundedButton";
import { PANEL_DURATION_IN_MS } from "package-common-react/lib/components/LegalButton/style";

import closeIcon from '../../images/close.svg';

export const CloseButton = styled(function(props) {
  return <RoundedButton {...props} size="60" src={closeIcon} alt="Fermer" />
})``;

const openPanel = keyframes`
  from { top: 100%; }
  to { top: 0%; }
`;
const closePanel = keyframes`
  from { top: 0%; }
  to { top: 100%; }
`;
export const Panel = styled.section`
  ${mixin("font.default", 13)};
  background: ${get('color.standard')};
  bottom: 0;
  color: #fff;
  left: 0;
  overflow: auto;
  padding: ${toggle('isHome', '25px', '125px 25px 25px 25px')};
  position: fixed;
  right: 0;
  text-align: left;
  top: 0;
  z-index: 900;

  &.exited {
    top: 100%;
  }
  &.entering {
    animation: ${openPanel} ${PANEL_DURATION_IN_MS}ms ease;
    animation-fill-mode: forwards;
  }
  &.entered {
    top: 0%;
  }
  &.exiting {
    animation: ${closePanel} ${PANEL_DURATION_IN_MS}ms ease;
    animation-fill-mode: forwards;
  }

  h2 {
    ${mixin("font.bold", 16)};
    margin: 1em 0;
    padding: 0;
  }
  h3 {
    ${mixin("font.bold", 13)};
    margin: 0.5em 0;
    padding: 0;
  }
  p {
    margin: 0 0 0.5em 0;
    padding: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/LegalInformations/style.js